import { ReferenceGroup as ReferenceGroupType } from '@/types/reference';
import { AnnotationItem } from '@/components/Map/Drawer/BioEntityDrawer/AnnotationItem';
import React from 'react';
import { DEFAULT_REFERENCE_SOURCE } from '../ReactionDrawer.constants';

export interface Props {
  group: ReferenceGroupType;
}

export const ReferenceGroup = ({ group: { source, references } }: Props): JSX.Element => (
  <>
    <h3 className="font-semibold">Source: {source || DEFAULT_REFERENCE_SOURCE}</h3>
    {references.map(reference => (
      <AnnotationItem
        key={reference.id}
        type={reference.type}
        link={reference.link}
        resource={reference.resource}
      />
    ))}
  </>
);
